import accountActivity from './AccountActivity';
import Route from './route';

export default {
  RenderProp: accountActivity,
  mainRoute: Route,
};
